<template>
  <app-modal class="modal-day-month" @closeModal="closeModalQuarter">
    <h3 slot="header">Quarters</h3>
    <SelectDayMonthQuarter
      :key="`SelectDayMonthQuarte${key}`"
      ref="quatersComponent"
      :quarters.sync="quarters"
    />

    <div slot="footer" class="d-flex">
      <button
        class="input-ui-sm btn btn-default btn-cancel mr10"
        @click="closeModalQuarter"
      >
        {{ $t("form.button.close") }}
      </button>
      <button
        class="input-ui-sm btn btn-carma btn-save"
        @click="saveSettingsFields"
      >
        {{ $t("form.button.save") }}
      </button>
    </div>
  </app-modal>
</template>

<script>
import { get, isArray } from "lodash";
import AppModal from "../../modal";
import SelectDayMonthQuarter from "../../form-components/select-day-month/select-day-month-quarter";

export default {
  name: "StandardBreakdownQuarter",

  components: {
    SelectDayMonthQuarter,
    AppModal,
  },

  props: {
    settingsFields: {
      type: Object,
      required: true,
    },
    currentYear: {
      type: Number,
      required: false,
      default: () => {
        return new Date().getFullYear();
      },
    },
    nextYear: {
      type: Number,
      required: false,
      default: () => {
        return new Date().getFullYear() + 1;
      },
    },
  },

  data: function () {
    return {
      key: 0,
      months: [],
      quarters: [
        {
          start: "2010-1-1",
          end: "2010-3-31",
          startNextYear: false,
          endNextYear: false,
        },
        {
          start: "2010-4-1",
          end: "2010-6-30",
          startNextYear: false,
          endNextYear: false,
        },
        {
          start: "2010-7-1",
          end: "2010-9-30",
          startNextYear: false,
          endNextYear: false,
        },
        {
          start: "2010-10-1",
          end: "2010-12-31",
          startNextYear: false,
          endNextYear: false,
        },
      ],
    };
  },

  mounted() {
    this.currentYear = new Date().getFullYear();
    this.nextYear = this.currentYear + 1;
    this.setQuarters();
  },

  computed: {
    isDisabled() {
      if (get(this.$refs, "quatersComponent.isDateSequential"))
        return !this.$refs.quatersComponent.isDateSequential;

      return false;
    },
  },

  methods: {
    setQuarters() {
      if (Array.isArray(!this.settingsFields.q1.value)) {
        return this.setQuartersArray();
      }

      this.quarters = [];

      Object.values(this.settingsFields).forEach((item) => {
        let year;

        const newQuarter = {
          start: "",
          end: "",
        };

        if (
          item &&
          item.value &&
          isArray(item.value) &&
          item.value.length === 2
        ) {
          newQuarter.start = item.value[0];
          newQuarter.end = item.value[1];
        } else if (item && item.value && item.value.start && item.value.end) {
          newQuarter.start = item.value.start;
          newQuarter.end = item.value.end;
        }

        const splitedStart = newQuarter.start.split("-");
        const splitedEnd = newQuarter.end.split("-");
        const startYear = item.value.startNextYear
          ? this.nextYear
          : this.currentYear;
        const endYear = item.value.startNextYear
          ? this.nextYear
          : this.currentYear;

        if (splitedStart.length === 2 && !isArray(item.value)) {
          newQuarter.start = `${startYear}-${item.value.start}`;
          newQuarter.end = `${endYear}-${item.value.end}`;
        } else if (splitedStart.length === 2 && isArray(item.value)) {
          newQuarter.start = `${startYear}-${item.value[0]}`;
          newQuarter.end = `${endYear}-${item.value[1]}`;
        } else if (newQuarter.start.split("-").length === 3) {
          newQuarter.start = `${startYear}-${splitedStart[1]}-${splitedStart[2]}`;
          newQuarter.end = `${endYear}-${splitedEnd[1]}-${splitedEnd[2]}`;
        }

        this.quarters.push(newQuarter);
      });

      this.key++;
    },
    setQuartersArray() {
      this.quarters[0].start = this.fixFormat(
        this.settingsFields.q1.value[0],
        0,
        "start"
      );
      this.quarters[0].end = this.fixFormat(
        this.settingsFields.q1.value[1],
        0,
        "end"
      );

      this.quarters[1].start = this.fixFormat(
        this.settingsFields.q2.value[0],
        1,
        "start"
      );
      this.quarters[1].end = this.fixFormat(
        this.settingsFields.q2.value[1],
        1,
        "end"
      );

      this.quarters[2].start = this.fixFormat(
        this.settingsFields.q3.value[0],
        2,
        "start"
      );
      this.quarters[2].end = this.fixFormat(
        this.settingsFields.q3.value[1],
        2,
        "end"
      );

      this.quarters[3].start = this.fixFormat(
        this.settingsFields.q4.value[0],
        3,
        "start"
      );
      this.quarters[3].end = this.fixFormat(
        this.settingsFields.q4.value[1],
        3,
        "end"
      );
    },
    closeModalQuarter() {
      this.$emit("close-modal");
    },
    fixFormat(date, index, type) {
      const dateArray = date.split("-");

      if (!dateArray.length || dateArray.length > 3)
        return this.quarters[index][type];
      if (dateArray.length === 2)
        return `${this.currentYear}-${date[1]}-${date[2]}`;
      return date;
    },
    clearQuarterToSend(data) {
      const startArray = data.start.split("-");
      const endArray = data.end.split("-");

      data.start = `${startArray[1]}-${startArray[2]}`;
      data.end = `${endArray[1]}-${endArray[2]}`;

      data.startNextYear = startArray[0] == this.currentYear ? false : true;
      data.endNextYear = endArray[0] == this.currentYear ? false : true;

      return data;
    },
    saveSettingsFields() {
      const newData = {
        q1: this.clearQuarterToSend(this.quarters[0]),
        q2: this.clearQuarterToSend(this.quarters[1]),
        q3: this.clearQuarterToSend(this.quarters[2]),
        q4: this.clearQuarterToSend(this.quarters[3]),
      };

      if (
        this.$refs.quatersComponent &&
        this.$refs.quatersComponent.isDateSequential
      ) {
        this.$emit("on-save", newData);
        this.closeModalQuarter();
      }
      this.key++;
    },
  },
};
</script>

<style lang="scss">
.modal-mask.modal-day-month {
  .modal-wrapper {
    .modal-container {
      overflow: inherit;
    }
  }
}
</style>
